jQuery(document).ready(function ($) {
	// Footer navigation
	const footerNavPElements = document.querySelectorAll('.footer-navigation-mobile .footer-navigation-container p');

	footerNavPElements.forEach((element) => {
		element.addEventListener('click', () => {
			const nextElement = element.nextElementSibling;
			if (nextElement) {
				nextElement.classList.toggle('display-none');
				const ulElements = nextElement.querySelectorAll('ul');
				ulElements.forEach((ul) => ul.classList.toggle('display-none'));
			}
		});
	});

	// Header search
	$('.search-menu-buttons .menu-button-container').on({
		click: function () {
			$('.search-menu-buttons .menu-button-container .menu-button').toggleClass('hide');
			$('.top-container .search-menu-buttons .menu-button-container .close-button').toggleClass('show');
		},
	});

	// Header navigation
	const menuContainer = document.querySelector('.main-menu-section .main-menu-container .menu-main-menu-container ul.wp-block-navigation__container');
	const subMenus = document.querySelectorAll('.main-menu-section .main-menu-container [class*="sub-menu-"]');
	const menuItems = document.querySelectorAll('.main-menu-section .main-menu-container .menu-main-menu-container ul.wp-block-navigation__container > li');

	if (menuContainer) {
		menuContainer.addEventListener('click', function (e) {
			const clickedItem = e.target.closest('li.has-child');
			if (clickedItem) {
				const menuNumber = clickedItem.className.match(/menu-(\w+)/)[1];
				const correspondingSubMenu = document.querySelector(`.main-menu-section .main-menu-container .sub-menu-${menuNumber}`);

				// Toggle the current menu and submenu
				clickedItem.classList.toggle('active');
				if (correspondingSubMenu) {
					correspondingSubMenu.classList.toggle('menu-hover');
				}

				// Reset other menus and submenus
				subMenus.forEach((subMenu) => {
					if (!subMenu.classList.contains(`sub-menu-${menuNumber}`)) {
						subMenu.classList.remove('menu-hover');
					}
				});
				menuItems.forEach((item) => {
					if (item !== clickedItem) {
						item.classList.remove('active');
					}
				});

				multipleNavReset();
			}
		});
	}

	$('.main-menu-container .sub-menu .right-container ul.wp-block-navigation li.wp-block-navigation-submenu ul.wp-block-navigation-submenu li.wp-block-navigation-submenu button').on({
		click: function () {
			$('.main-menu-container .sub-menu .right-container .multiple-nav-menu > button').addClass('display-none');
			$('.main-menu-container .sub-menu .right-container .multiple-nav-menu > a').addClass('display-none');
			$('.main-menu-container .sub-menu .right-container .multiple-nav-menu.wp-block-navigation-submenu').css('left', '0px');
			$('.main-menu-container .sub-menu .right-container .multiple-nav-menu.wp-block-navigation-submenu').css('right', '0px');

			if ($('.revert-sub-menu-item').length === 0) {
				$('.main-menu-container .sub-menu .right-container nav').prepend('<a class="revert-sub-menu-item" href="#">Back to previous menu</a>');
			}
		},
	});

	$(document).on('click', '.revert-sub-menu-item', function () {
		multipleNavReset();
	});

	function multipleNavReset() {
		$('.main-menu-container .sub-menu .right-container .multiple-nav-menu > button').removeClass('display-none');
		$('.main-menu-container .sub-menu .right-container .multiple-nav-menu > a').removeClass('display-none');
		$('.main-menu-container .sub-menu .right-container .multiple-nav-menu.wp-block-navigation-submenu').css('left', '416px');
		$('.main-menu-container .sub-menu .right-container .multiple-nav-menu.wp-block-navigation-submenu').css('right', '-416px');

		$('.main-menu-container .sub-menu .right-container nav .revert-sub-menu-item').remove();

		$('.main-menu-container .sub-menu nav ul > li.wp-block-navigation-item.has-child.open-on-click.multiple-nav-menu.wp-block-navigation-submenu > button').removeClass('opened-menu');
		$('.main-menu-container .sub-menu nav ul > li.wp-block-navigation-item.has-child.open-on-click.multiple-nav-menu.wp-block-navigation-submenu > button').attr('aria-expanded', 'false');
	}

	$('.main-menu-container .sub-menu nav ul > li.wp-block-navigation-item.has-child.open-on-click.multiple-nav-menu.wp-block-navigation-submenu > button').on('click', function () {
		$('.main-menu-container .sub-menu nav ul > li.wp-block-navigation-item.has-child.open-on-click.multiple-nav-menu.wp-block-navigation-submenu > button').removeClass('opened-menu');
		$(this).addClass('opened-menu');
	});

	$('body').on({
		click: function (e) {
			const container = $('.menu-hover')[0];
			const nav = $('.menu-main-menu-container')[0];
			const menu = $('.main-menu-section .main-menu-container ul.menu-main-menu-container li');
			const menuThree = $('.main-menu-container .sub-menu nav ul > li.wp-block-navigation-item.has-child.open-on-click.multiple-nav-menu.wp-block-navigation-submenu > button.opened-menu');

			if (container && nav && menu.is('.active')) {
				if (container !== e.target && !container.contains(e.target) && nav !== e.target && !nav.contains(e.target)) {
					menu.each((index, link) => {
						if ($(link).hasClass('active')) {
							link.click();
						}
					});
				}

				if ($('.revert-sub-menu-item').length !== 0) {
					menuThree.attr('aria-expanded', 'true');
				}
			}

			if ($('.wp-block-msi-blocks-countries-navigation .container .select-country input').length != 0) {
				const navLanguage = $('.wp-block-msi-blocks-countries-navigation')[0];
				const navCountriesShow = $('.wp-block-msi-blocks-countries-navigation .container .select-country input').prop('checked');

				if (navCountriesShow && !navLanguage.contains(e.target)) {
					$('.wp-block-msi-blocks-countries-navigation .container .select-country input').prop('checked', false);
				}
			}
		},
	});

	// Header navigation mobile
	$('.search-menu-buttons .menu-button-container .menu-button').on({
		click: function () {
			$('.header-mobile .menu-mobile-container').addClass('on');
			$('.header-mobile .bottom-container').addClass('on');
			$('.menu-mobile-container')[0].scrollIntoView({behavior: 'smooth'});
		},
	});

	$('.search-menu-buttons .menu-button-container .close-button').on({
		click: function () {
			$('.header-mobile .menu-mobile-container').removeClass('on');
			$('.header-mobile .bottom-container').removeClass('on');

			$('.header-mobile .menu-mobile-container .submenu').removeClass('menu-active');
			$('.header-mobile .menu-mobile-container .menu-main-menu-container ul > li.active').removeClass('active');
			$('.header-mobile .menu-mobile-container .menu-main-menu-container ul > li.active-li').show();
			$('.header-mobile .menu-mobile-container .menu-main-menu-container ul > li.active-li').removeClass('active-li');
			$('.header-mobile .menu-mobile-container .submenu ul.wp-block-navigation__container > li.has-child.active-sub-li').removeClass('active-sub-li');
			$('.header-mobile .menu-mobile-container .submenu ul.wp-block-navigation__container li.active-sub').removeClass('active-sub');
		},
	});

	$('.header-mobile .menu-mobile-container .menu-main-menu-container ul > li.has-child').click(function ($e) {
		$e.preventDefault();
	});

	// remove wp interactivity close on focusout
	const mobileSubMenuItems = document.querySelectorAll('.header-mobile .menu-mobile-container li.has-child');
	mobileSubMenuItems.forEach((element) => {
		element.removeAttribute('data-wp-on--focusout');
	});

	const mobileMenuContainer = document.querySelector('.header-mobile .menu-mobile-container .menu-main-menu-container ul');
	const mobileSubMenus = document.querySelectorAll('.header-mobile .menu-mobile-container .menu-main-menu-container [class*="submenu-"]');
	const mobileMenuItems = document.querySelectorAll('.header-mobile .menu-mobile-container .menu-main-menu-container ul > li');

	if (mobileMenuContainer) {
		mobileMenuContainer.addEventListener('click', function (e) {
			const clickedItem = e.target.closest('li.has-child');
			if (clickedItem) {
				const menuNumber = clickedItem.className.match(/menu-(\w+)/)[1];
				const correspondingSubMenu = document.querySelector(`.header-mobile .menu-mobile-container .submenu-${menuNumber}`);

				// Toggle the current menu and submenu
				clickedItem.classList.toggle('active-li');
				if (correspondingSubMenu) {
					correspondingSubMenu.classList.toggle('menu-active');
				}

				// Reset other menus and submenus
				mobileSubMenus.forEach((subMenu) => {
					if (!subMenu.classList.contains(`sub-menu-${menuNumber}`)) {
						subMenu.classList.toggle('menu-active');
					}
				});
				mobileMenuItems.forEach((item) => {
					if (item !== clickedItem) {
						item.classList.toggle('active');
						item.classList.remove('active-li');
					}
				});

				$('.menu-mobile-container')[0].scrollIntoView({behavior: 'smooth'});
			}
		});
	}

	$(document).on('click', '.header-mobile .menu-mobile-container .submenu li.has-child button', function (event) {
		event.stopPropagation();

		const $listItem = $(this).parent();
		const level = $listItem.parents('ul.wp-block-navigation__submenu-container').length;
		if (level == 0) {
			$('.header-mobile .menu-mobile-container .menu-main-menu-container').toggleClass('active-submenu-covered');
		} else {
			$listItem.parent().closest('li.has-child').find('>button').toggleClass('active-submenu-covered');
		}
		$listItem.closest('ul').find('>li').not($listItem).toggleClass('active-sub');
		$listItem.toggleClass('active-sub-li');

		let $button = $listItem.find('>button');
		if ($listItem.hasClass('active-sub-li')) {
			$button.attr('aria-expanded', 'true');
		} else {
			$button.attr('aria-expanded', 'false');
		}

		$('.menu-mobile-container')[0].scrollIntoView({behavior: 'smooth'});
	});

	// bar chart animation
	if ($('.wp-block-b-chart-chart')) {
		function waitForCanvas(callback) {
			const checkInterval = 100;
			let attempts = 0;
			const maxAttempts = 500;

			const intervalId = setInterval(() => {
				if ($('.bChart canvas').length > 0) {
					clearInterval(intervalId);
					callback();
				} else {
					attempts++;
					if (attempts >= maxAttempts) {
						clearInterval(intervalId);
					}
				}
			}, checkInterval);
		}

		function waitForChartInitialization(canvasEl, callback) {
			const checkInterval = 100;
			let attempts = 0;
			const maxAttempts = 500;

			const intervalId = setInterval(() => {
				const chart = Chart.getChart(canvasEl);

				if (chart) {
					clearInterval(intervalId);
					callback(chart);
				} else {
					attempts++;
					if (attempts >= maxAttempts) {
						clearInterval(intervalId);
					}
				}
			}, checkInterval);
		}

		function isCanvasVisible(canvas) {
			const rect = canvas.getBoundingClientRect();
			const offset = 50;
			return rect.top >= -offset && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + offset;
		}

		function handleScroll(chart, canvas) {
			if (isCanvasVisible(canvas)) {
				if (!chart.animationStarted) {
					chart.update('show');
					chart.animationStarted = true;
				}
			} else {
				chart.update('reset');
				chart.animationStarted = false;
			}
		}

		function initAnimation() {
			$('.bChart canvas').each(function () {
				const canvas = this;
				waitForChartInitialization(canvas, (chart) => {
					chart.update('reset');
					chart.animationStarted = false;
					chart.options.animation.duration = 1800;
					window.addEventListener('scroll', handleScroll.bind(this, chart, canvas));
					handleScroll(chart, canvas);
				});
			});
		}

		waitForCanvas(initAnimation);
	}

	/**
	 * Carousel block arrow position
	 */
	if ( $('.fld-carousel-slider').length > 0 ) {
		$(window).on('load resize', function () {
			const fldSlickDots = $('.fld-carousel-slider .slick-dots li').length;

			$('.fld-carousel-slider .slick-next.slick-arrow').css("transform", "translate(" + fldSlickDots * 20 + "px, -70%)");
			$('.fld-carousel-slider .slick-prev.slick-arrow').css("transform", "translate(-" + fldSlickDots * 20 + "px, -50%)");
		});
	}

});
